const invalidKeys = Object.getOwnPropertyNames(Object.prototype)

class FetchError extends Error {
  type: string
  code: string
  causedBy: any

  constructor(options) {
    const { type, code, message, causedBy, ...customFields } = options || {}
    super(message)

    this.type = type
    this.code = code
    this.message = message
    this.causedBy = causedBy

    // Prevent some keys from being overridden
    Object.keys(customFields).forEach((key) => {
      if (!invalidKeys.includes(key)) {
        this[key] = customFields[key]
      }
    })

    // Exclude constructor call from the stack trace
    if (typeof Error.captureStackTrace === 'function') {
      Error.captureStackTrace(this, this.constructor)
    } else {
      this.stack = new Error(toString()).stack
    }
  }

  toString() {
    return this.message
  }

  formatErrorMessage(message) {
    let msg = `FetchError: ${message || ''}`
    if (!message) {
      msg = this.type || ''
      if (this.code) {
        msg += this.type ? ` - ${this.code}` : this.code
      }
    }

    if (this.causedBy) {
      msg += ` (Caused by: ${this.causedBy.message})`
    }

    return msg
  }
}

export default FetchError
